import { useSearchParams } from "react-router-dom";

// Generic tabbed container used to merge several admin pages into one section
// without changing their behaviour. Each tab renders an existing admin page as-is.
// The active tab is kept in the URL (?tab=key) so it survives reloads + deep links.
export default function AdminTabsHub({ title, subtitle, tabs, idPrefix = "hub" }) {
  const [params, setParams] = useSearchParams();
  const keys = tabs.map((t) => t.key);
  const requested = params.get("tab");
  const active = keys.includes(requested) ? requested : keys[0];
  const setActive = (k) => {
    const next = new URLSearchParams(params);
    next.set("tab", k);
    setParams(next, { replace: true });
  };
  const current = tabs.find((t) => t.key === active) || tabs[0];

  return (
    <div data-testid={`${idPrefix}-hub`}>
      <div className="mb-5">
        <h1 className="font-serif-latin text-2xl text-ink">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-ink-3">{subtitle}</p>}
      </div>

      <div className="mb-6 flex flex-wrap gap-1 border-b border-line">
        {tabs.map((t) => (
          <button
            key={t.key}
            data-testid={`${idPrefix}-tab-${t.key}`}
            onClick={() => setActive(t.key)}
            className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm transition-colors ${
              t.key === active
                ? "border-b-2 border-saffron text-saffron"
                : "border-b-2 border-transparent text-ink-2 hover:text-ink"
            }`}
          >
            {t.icon && <t.icon className="h-4 w-4" />} {t.label}
          </button>
        ))}
      </div>

      {/* Remount per tab so page-level state (forms, fetches) resets cleanly */}
      <div key={active} data-testid={`${idPrefix}-panel-${active}`}>
        {current.render()}
      </div>
    </div>
  );
}
